function initializeSaltFilters(root = document) {
  root.querySelectorAll('[data-ss-products]').forEach((section) => {
    if (section.dataset.ssReady) return;
    section.dataset.ssReady = 'true';
    const filters = section.querySelector('.ss-filters');
    const cards = [...section.querySelectorAll('[data-ss-category]')];
    const status = section.querySelector('[data-ss-product-count]');
    filters.hidden = false;
    filters.addEventListener('change', (event) => {
      const category = event.target.value;
      if (!['all', 'food', 'bath', 'gift'].includes(category)) return;
      cards.forEach((card) => {
        card.hidden = category !== 'all' && card.dataset.ssCategory !== category;
      });
      status.textContent = `${cards.filter((card) => !card.hidden).length}件の商品`;
    });
  });
}

function initializeSaltPromotions(root = document) {
  root.querySelectorAll('.ss-promotions').forEach((promotions) => {
    if (promotions.dataset.ssReady) return;
    promotions.dataset.ssReady = 'true';
    const track = promotions.querySelector('[data-ss-promo-track]');
    const cards = [...track.children];
    const dots = promotions.querySelector('[data-ss-promo-dots]');
    const previous = promotions.querySelector('[data-ss-promo-prev]');
    const next = promotions.querySelector('[data-ss-promo-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let page = 0;
    let pageCount = 1;
    let timer;

    const pageSize = () => window.matchMedia('(max-width: 749px)').matches ? 4 : 2;
    const updateDots = () => {
      [...dots.children].forEach((dot, index) => dot.setAttribute('aria-current', String(index === page)));
    };
    const goTo = (index, smooth = true) => {
      page = (index + pageCount) % pageCount;
      const target = cards[page * pageSize()];
      if (target) track.scrollTo({ left: target.offsetLeft - cards[0].offsetLeft, behavior: smooth && !reducedMotion.matches ? 'smooth' : 'instant' });
      updateDots();
    };
    const buildDots = () => {
      pageCount = Math.max(1, Math.ceil(cards.length / pageSize()));
      page = Math.min(page, pageCount - 1);
      dots.replaceChildren();
      for (let index = 0; index < pageCount; index += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', `バナー ${index + 1} を表示`);
        dot.addEventListener('click', () => goTo(index));
        dots.append(dot);
      }
      promotions.querySelector('.ss-promotions__controls').hidden = pageCount < 2;
      goTo(page, false);
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (pageCount > 1 && !reducedMotion.matches && !document.hidden) {
        timer = setInterval(() => {
          if (!promotions.isConnected) return stop();
          goTo(page + 1);
        }, 5500);
      }
    };

    previous.addEventListener('click', () => goTo(page - 1));
    next.addEventListener('click', () => goTo(page + 1));
    promotions.addEventListener('mouseenter', stop);
    promotions.addEventListener('mouseleave', start);
    promotions.addEventListener('focusin', stop);
    promotions.addEventListener('focusout', (event) => {
      if (!promotions.contains(event.relatedTarget)) start();
    });
    document.addEventListener('visibilitychange', start);
    reducedMotion.addEventListener('change', start);
    window.addEventListener('resize', () => { buildDots(); start(); });
    track.addEventListener('scroll', () => {
      const nearest = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      page = Math.min(pageCount - 1, nearest);
      updateDots();
    }, { passive: true });
    buildDots();
    start();
  });
}
initializeSaltFilters();
initializeSaltPromotions();
document.addEventListener('shopify:section:load', (event) => {
  initializeSaltFilters(event.target);
  initializeSaltPromotions(event.target);
});
